import { Theme } from "@mui/material/styles";
import darkTheme from "./darkTheme";
import lightTheme from "./lightTheme";

const themes: { dark: Theme; light: Theme } = {
  dark: darkTheme,
  light: lightTheme,
};
export default themes;
